import React from 'react';
import getCategoryPath from './getCategoryPath';
import { translateCategoryPath } from './categories';
import LinkAndAnchor from '../components/LinkAndAnchor';

const getCategoryBreadcrumb = (category, hasLocalNews, intl) => (
  category.path.includes('/') && (
    <LinkAndAnchor
      route="category"
      params={{
        categoryPath: translateCategoryPath(
          category.path.replace(/\/.+/, ''),
        ),
      }}
    >
      {getCategoryPath(category, hasLocalNews, intl)}
    </LinkAndAnchor>
  )
);

export default getCategoryBreadcrumb;
